import React, { useEffect } from 'react';
import './styles.css';
import { BupSpinner, Comment } from '@BUP/components';

const CommentList = ({
	comments,
	user,
	isLoading,
	chatContainerRef,
	isCaseOpen
}) => {

	return (
		<div
			className="message-list-container"
			ref={chatContainerRef}
		>
			{
				isLoading ? (<BupSpinner size="medium" />) :
					comments && comments.length ?
						comments.map((comment, idx) => (
							<Comment
								key={`chatbox-comment-${idx}`}
								comment={comment}
								user={user}
								isCaseOpen={isCaseOpen}
							/>
						))
						: (<p>No hay mensajes ...</p>)
			}
		</div>
	);
};

export default CommentList;